
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class HinaDatePicker extends Vue {
  @Prop() value!: any;
  @Prop({ default: "100%" }) width!: string;

  v = this.value;

  @Watch("value", { immediate: true })
  handleValueChange() {
    this.v = this.value;
  }

  handleChange() {
    this.$emit("update:value", this.v);
    this.$emit("change", this.v);
  }
}
